<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8334 2.69824H7.49997C7.05841 2.6995 6.63529 2.87544 6.32303 3.18764C6.01077 3.49984 5.83475 3.92292 5.83341 4.36448V15.1977C5.83279 15.4183 5.74471 15.6297 5.58848 15.7855C5.43225 15.9413 5.22062 16.0288 4.99998 16.0288C4.77935 16.0288 4.56771 15.9413 4.41148 15.7855C4.25525 15.6297 4.16717 15.4183 4.16655 15.1977V6.865C4.16686 6.75538 4.14553 6.64677 4.10379 6.54541C4.06205 6.44404 4.00073 6.35191 3.92332 6.27429C3.84591 6.19666 3.75395 6.13508 3.6527 6.09306C3.55145 6.05103 3.4429 6.0294 3.33328 6.0294C3.22365 6.0294 3.11511 6.05103 3.01386 6.09306C2.91261 6.13508 2.82064 6.19666 2.74324 6.27429C2.66583 6.35191 2.6045 6.44404 2.56276 6.54541C2.52102 6.64677 2.4997 6.75538 2.5 6.865V15.1977C2.50051 15.6691 2.63466 16.1307 2.88689 16.529C3.13911 16.9272 3.49909 17.2458 3.92504 17.4478C4.25968 17.6118 4.62729 17.6975 4.99997 17.6982H15.8334C16.2752 17.6969 16.6984 17.5208 17.0107 17.2084C17.323 16.8959 17.4989 16.4726 17.5 16.0308V4.36448C17.4987 3.92292 17.3226 3.49983 17.0104 3.18763C16.6981 2.87543 16.275 2.69949 15.8334 2.69824ZM15.8334 16.0308H7.49997V4.36448H15.8334V16.0308ZM9.99995 8.53147H13.3334C13.5533 8.52962 13.7635 8.441 13.9183 8.2849C14.0731 8.1288 14.1599 7.91787 14.1599 7.69804C14.1599 7.4782 14.0731 7.26727 13.9183 7.11117C13.7635 6.95507 13.5533 6.86645 13.3334 6.8646H9.99995C9.78012 6.86645 9.56992 6.95507 9.41512 7.11117C9.26033 7.26727 9.17347 7.4782 9.17347 7.69804C9.17347 7.91787 9.26033 8.1288 9.41512 8.2849C9.56992 8.441 9.78012 8.52962 9.99995 8.53147ZM9.99995 11.8647H11.6668C11.8874 11.864 12.0988 11.776 12.2546 11.6197C12.4104 11.4635 12.4979 11.2519 12.4979 11.0313C12.4979 10.8106 12.4104 10.599 12.2546 10.4428C12.0988 10.2866 11.8874 10.1985 11.6668 10.1979H9.99995C9.77932 10.1985 9.56794 10.2866 9.41215 10.4428C9.25636 10.599 9.16887 10.8106 9.16887 11.0313C9.16887 11.2519 9.25636 11.4635 9.41215 11.6197C9.56794 11.776 9.77932 11.864 9.99995 11.8647Z"
      :fill="decideColor"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String, // active (red), inactive (grey), filled (white)
      required: false,
      default: "inactive",
    },
  },
  computed: {
    decideColor() {
      if (this.color === "inactive") {
        return "#4D4D4D";
      } else if (this.color === "active") {
        return "#B82025";
      } else {
        return "#FFFFFF";
      }
    },
  },
};
</script>
